import logger from '@cash-web/shared/util-logger'

export const SUPPORTED_LOCALES = ['en-US', 'es-US'] as const
export const DEFAULT_LOCALE: PreferredLocale = 'en-US'

export type PreferredLocale = (typeof SUPPORTED_LOCALES)[number]

function isSupportedLocale(value: unknown): value is PreferredLocale {
  return SUPPORTED_LOCALES.includes(value as PreferredLocale)
}

function getPreferredLocale(): string | undefined {
  if (typeof window === 'undefined' || !('locale' in window)) {
    return undefined
  }

  return window.locale as string
}

/**
 * The non-hook half of [usePreferredLocale], for callers that have to resolve the locale outside a
 * component — notably the account shell's RUM stamp, which runs at module evaluation so the
 * attribute lands before the first render can throw. Exported so those callers reuse this
 * validation and fallback instead of re-deriving them from `window.locale`.
 */
export function resolvePreferredLocale(): PreferredLocale {
  const preferredLocale = getPreferredLocale()

  if (!isSupportedLocale(preferredLocale)) {
    logger.warn(new Error(`Unsupported locale "${preferredLocale}", defaulting to "${DEFAULT_LOCALE}"`))

    return DEFAULT_LOCALE
  }

  return preferredLocale
}

export function usePreferredLocale(): PreferredLocale {
  return resolvePreferredLocale()
}
